// src/pages/NuevaCotizacion.jsx
import React, { useEffect, useState } from "react";
import { onSnapshot, orderBy, query } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import CotizacionForm from "../components/CotizacionForm";
import TablaCotizaciones from "../components/TablaCotizaciones";
import PreviaCotizacion from "../components/PreviaCotizacion";
import { orgCollection } from "../utils/firePaths";

export default function NuevaCotizacion({ mostrarBotonNuevo }) {
  const { user, orgId } = useAuth();
  const [cotizaciones, setCotizaciones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mostrarPrevia, setMostrarPrevia] = useState(false);
  const [cotizacionSeleccionada, setCotizacionSeleccionada] = useState(null);

  // 1) Cotizaciones en tiempo real (ORG)
  useEffect(() => {
    if (!user?.uid || !orgId) return;

    const cotRef = orgCollection(orgId, "cotizaciones");
    // Recomendado ordenar por createdAt si existe; si no, usa numeroCotizacion
    const qCot = query(cotRef, orderBy("createdAt", "desc"));

    const unsub = onSnapshot(qCot, (snap) => {
      setCotizaciones(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    return () => unsub();
  }, [user?.uid, orgId]);

  // 2) Clientes en tiempo real (ORG)
  useEffect(() => {
    if (!user?.uid || !orgId) return;

    const cliRef = orgCollection(orgId, "clientes");
    const qCli = query(cliRef, orderBy("empresa", "asc"));

    const unsub = onSnapshot(qCli, (snap) => {
      setClientes(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    return () => unsub();
  }, [user?.uid, orgId]);

  const activarFormulario = () => {
    setCotizacionSeleccionada(null);
    setMostrarFormulario(true);
  };

  const closeModal = () => {
    setMostrarFormulario(false);
    setCotizacionSeleccionada(null);
  };

  const verPrevia = (cot) => {
    setCotizacionSeleccionada(cot);
    setMostrarPrevia(true);
  };

  return (
    <div>
      {!mostrarFormulario && !mostrarPrevia && mostrarBotonNuevo && (
        <button className="action-button2" onClick={activarFormulario}>
          + Nuevo
        </button>
      )}

      {mostrarFormulario ? (
        <CotizacionForm
          cotizacion={cotizacionSeleccionada}
          cotizaciones={cotizaciones}
          onFormDirtyChange={() => {}}
          closeModal={closeModal}
          cloneMode={false}
        />
      ) : mostrarPrevia ? (
        <PreviaCotizacion
          cotizacion={cotizacionSeleccionada}
          cerrarPrevia={() => setMostrarPrevia(false)}
          clientes={clientes}
          numeroCotizacion={cotizacionSeleccionada?.numeroCotizacion}
        />
      ) : (
        <TablaCotizaciones
          cotizaciones={cotizaciones}
          setCotizaciones={setCotizaciones}
          clientes={clientes}
          verPrevia={verPrevia}
        />
      )}
    </div>
  );
}